import { OrgAdminConstants } from '../../../_constants';

const initialState = { getModulePermissionsLoading: true, data: '', error: false };

export function getModulePermissionsListReducer(state = initialState, action) {

    switch (action.type) {
        case OrgAdminConstants.REQUEST_MODULE_PERMISSIONS_LIST:
            return {
                getModulePermissionsLoading: true,
                data: '',
                error: false
            };
        case OrgAdminConstants.RECEIVE_MODULE_PERMISSIONS_LIST:
            return {
                getModulePermissionsLoading: false,
                data: action.getModulePermissionList,
                error: false
            };
        case OrgAdminConstants.MODULE_PERMISSIONS_LIST_ERROR:
            return {
                getModulePermissionsLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/OrgAdmin/ModulePermissions/getModulePermissions.reducer.js